import { AfterViewInit, Component, HostBinding, HostListener } from '@angular/core';
import { CoordinatorService } from 'coordinator';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [
        // SectionFooterComponent,
        // StageManagerComponent,
        // StageReaderComponent,
        // StageNotepadComponent,
        // StageAiComponent,
        // StageHubComponent,
        CommonModule,
    ],

    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements AfterViewInit {
    // @HostBinding('@.disabled') // Animation module is not longer imported
    title = 'patentka';
    isMobile = window.innerWidth < 768;

    hubComponent: any;
    stageManagerComponent: any;
    stageNotepadComponent: any;
    stageReaderComponent: any;
    stageAiComponent: any;
    stageLicenseComponent: any;
    sectionFooterComponent: any;

    dialogHubUploadComponent: any;
    dialogStartComponent: any;

    dialogPdfComponent: any;
    dialogBulkComponent: any;

    dialogConnectionStep1Component: any;
    dialogConnectionStep2Component: any;
    dialogConnectionStep3Component: any;
    dialogConnectionStep4Component: any;

    dialogDeleteComponent: any;
    dialogUserDetailComponent: any;
    dialogInProgressActionsComponent: any;
    dialogOpenProjectInProgressComponent: any;
    dialogSystemComponent: any;
    dialogScriptsComponent: any;
    dialogConnectionOnlineComponent: any;
    dialogConnectionScriptComponent: any;
    dialogLogsComponent: any;
    dialogAttachmentComponent: any;
    dialogAttachmentEditComponent: any;
    dialogImageComponent: any;
    dialogHelpInContextComponent: any;
    dialogMouseOverComponent: any;
    dialogMenuComponent: any;
    dialogMessageComponent: any;
    dialogChapterInsertComponent: any;
    dialogSaveComponent: any;
    dialogCloudCacheConflictComponent: any;
    dialogSaveHitsetComponent: any;
    dialogSearchViewsComponent: any;
    dialogSearchBinaryTreeComponent: any;
    dialogSearchConditionsComponent: any;
    dialogConfirmComponent: any;
    dialogExportComponent: any;
    dialogShareComponent: any;
    dialogProjectListComponent: any;
    dialogNotepadListComponent: any;
    dialogReaderListComponent: any;
    dialogSortComponent: any;
    dialogKeywordComponent: any;
    dialogKeywordGroupEditorComponent: any;
    dialogItemDetailPanelSelectionComponent: any;
    dialogTeamInvitationComponent: any;
    dialogTeamGenerateCodeComponent: any;
    dialogTeamChangeRoleComponent: any;
    dialogTeamGroupInvitationComponent: any;
    dialogMoreComponent: any;
    dialogFilterPanel2Component: any;
    dialogTagsEditorComponent: any;
    dialogRatingsEditorComponent: any;
    dialogConditionsEditorComponent: any;
    dialogValuesEditorComponent: any;
    dialogFormulaEditorComponent: any;
    dialogLoginComponent: any;
    dialogLogoutComponent: any;
    dialogInvitationCodeAcceptComponent: any;
    dialogUserIdentificatorComponent: any;
    dialogCloudErrorComponent: any;
    dialogColumnCPreviewComponent: any;
    dialogAddCollectionItemComponent: any;
    dialogLocalToCloudComponent: any;
    dialogSearchArchiveComponent: any;
    dialogNotepadComponent: any;
    dialogNoteXitemComponent: any;
    dialogItemDetailComponent: any;
    dialogStoryItemNotepadItemsComponent: any;
    dialogReportAsProjectComponent: any;
    dialogPublicationComponent: any;
    dialogProjectNewComponent: any;
    dialogReportPreviewComponent: any;
    dialogUserGroupComponent: any;
    dialogUploadInfoComponent: any;
    stageExportLinkDialogComponent: any;
    dialogDevtoolsComponent: any;
    dialogAutouserTransferComponent: any;
    dialogAutouserEditBinaryTreeComponent: any;
    dialogBatchSelectionComponent: any;
    dialogBatchReferencesComponent: any;
    dialogEvidenceQuoteComponent: any;
    dialogUserGroupListComponent: any;
    dialogUserLicenseComponent: any;
    dialogUnsubscribeComponent: any;
    dialogMemowlWebComponent: any;
    dialogProvidersComponent: any;
    dialogCountdownComponent: any;

    constructor(
        public coords: CoordinatorService,
        private activatedRoute: ActivatedRoute,
        private dialog: MatDialog,
        private titleService: Title,
        private metaService: Meta,
    ) {
        const intervalPreloader = setInterval(() => {
            if (this.coords.worker$.isReady) {
                document.body.style.backgroundColor = '#fff';
                const preloader =
                    document.getElementById('preloader') ||
                    document.getElementById('preloader_memowl');
                if (preloader) {
                    preloader.style.display = 'none';
                }
                clearInterval(intervalPreloader);
            }
        }, 100);
        this.coords.display$.dialog$.subscribe((x) => {
            if (this.coords.project$.isLoading) return;
            if (x.action === 'close') {
                const stalone = this.coords.display$.standaloneDialog;
                if (stalone) {
                    stalone.close();
                    this.coords.display$.standaloneDialog = undefined;
                    this.coords.display$.markForCheck();
                    return;
                }
                const ec$ = this.coords.databin$.editedConnection$;
                if (ec$.getValue()) ec$.next(undefined);
                this._dialogRef && this._dialogRef.close();
                this.coords.display$.markForCheck();
                return;
            }
            this._miscDialog(x);
        });

        this.coords.display$.markForCheck$.subscribe(() => {
            if (this.coords.project$.current || this._dialogRef) return;
            if (!this.isMobile) {
                this._miscDialog({ action: 'start' });
            }
        });
    }

    ngOnInit() {
        const lDiv = document.getElementById('pre-load-screen');
        if (lDiv) {
            lDiv.style.display = 'none';
        }

        this.activatedRoute.queryParams.subscribe((params) => {
            this.coords.display$.markForCheck();
            const eduId: string = params['eduid'];
            const eduiv: string = params['eduiv'];
            const pcode: string = params['pcode'];
            if (eduId) {
                this.coords.display$.isExternalLogin = true;
                this._dialogRef?.close();
                this.coords.eduid$.eduidResponse(eduId, eduiv);
            }

            if (pcode) {
                const newUrl = window.location.protocol + '//' + window.location.host;
                window.history.pushState({ path: newUrl }, '', newUrl);
                this.coords.project$.urlPcode(pcode);
            }
        });
        this.coords.display$.checkScreenTablet();
    }

    ngAfterViewInit() {
        // Trigger lazy load immediately after view init

        import('./dialog-start/dialog-start.component').then((m) => {
            this.dialogStartComponent = m.DialogStartComponent;
        });

        import('./stage-license/stage-license.component').then((m) => {
            this.stageLicenseComponent = m.StageLicenseComponent;
        });

        import('./stage-hub/stage-hub.component').then((m) => {
            this.hubComponent = m.StageHubComponent;
        });
        import('./dialog-hub-upload/dialog-hub-upload.component').then((m) => {
            this.dialogHubUploadComponent = m.DialogHubUploadComponent;
        });
        import('./dialog-pdf/dialog-pdf.component').then((m) => {
            this.dialogPdfComponent = m.DialogPdfComponent;
        });

        import('./dialog-bulk/dialog-bulk.component').then((m) => {
            this.dialogBulkComponent = m.DialogBulkComponent;
        });

        import('./stage-manager/stage-manager.component').then((m) => {
            this.stageManagerComponent = m.StageManagerComponent;
        });

        import('./stage-notepad/stage-notepad.component').then((m) => {
            this.stageNotepadComponent = m.StageNotepadComponent;
        });

        import('./stage-ai/stage-ai.component').then((m) => {
            this.stageAiComponent = m.StageAiComponent;
        });

        import('./stage-reader/stage-reader.component').then((m) => {
            this.stageReaderComponent = m.StageReaderComponent;
        });

        import('./dialog-connection-step1/dialog-connection-step1.component').then((m) => {
            this.dialogConnectionStep1Component = m.DialogConnectionStep1Component;
        });
        import('./dialog-connection-step2/dialog-connection-step2.component').then((m) => {
            this.dialogConnectionStep2Component = m.DialogConnectionStep2Component;
        });
        import('./dialog-connection-step3/dialog-connection-step3.component').then((m) => {
            this.dialogConnectionStep3Component = m.DialogConnectionStep3Component;
        });
        import('./dialog-connection-step4/dialog-connection-step4.component').then((m) => {
            this.dialogConnectionStep4Component = m.DialogConnectionStep4Component;
        });

        import('./section-footer/section-footer.component').then((m) => {
            this.sectionFooterComponent = m.SectionFooterComponent;
        });

        import('./dialog-delete/dialog-delete.component').then((m) => {
            this.dialogDeleteComponent = m.DialogDeleteComponent;
        });

        import('./dialog-user-detail/dialog-user-detail.component').then((m) => {
            this.dialogUserDetailComponent = m.DialogUserDetailComponent;
        });

        import('./dialog-in-progress-actions/dialog-in-progress-actions.component').then((m) => {
            this.dialogInProgressActionsComponent = m.DialogInProgressActionsComponent;
        });

        import('./dialog-open-project-in-progress/dialog-open-project-in-progress.component').then(
            (m) => {
                this.dialogOpenProjectInProgressComponent = m.DialogOpenProjectInProgressComponent;
            },
        );

        import('./dialog-system/dialog-system.component').then((m) => {
            this.dialogSystemComponent = m.DialogSystemComponent;
        });

        import('./dialog-scripts/dialog-scripts.component').then((m) => {
            this.dialogScriptsComponent = m.DialogScriptsComponent;
        });

        import('./dialog-connection-online/dialog-connection-online.component').then((m) => {
            this.dialogConnectionOnlineComponent = m.DialogConnectionOnlineComponent;
        });

        import('./dialog-connection-online/dialog-connection-online.component').then((m) => {
            this.dialogConnectionOnlineComponent = m.DialogConnectionOnlineComponent;
        });

        import('./dialog-logs/dialog-logs.component').then((m) => {
            this.dialogLogsComponent = m.DialogLogsComponent;
        });

        import('./dialog-attachment/dialog-attachment.component').then((m) => {
            this.dialogAttachmentComponent = m.DialogAttachmentComponent;
        });

        import('./dialog-attachment-edit/dialog-attachment-edit.component').then((m) => {
            this.dialogAttachmentEditComponent = m.DialogAttachmentEditComponent;
        });

        import('./dialog-image/dialog-image.component').then((m) => {
            this.dialogImageComponent = m.DialogImageComponent;
        });

        import('./dialog-help-in-context/dialog-help-in-context.component').then((m) => {
            this.dialogHelpInContextComponent = m.DialogHelpInContextComponent;
        });

        import('./dialog-mouse-over/dialog-mouse-over.component').then((m) => {
            this.dialogMouseOverComponent = m.DialogMouseOverComponent;
        });

        import('./dialog-menu/dialog-menu.component').then((m) => {
            this.dialogMenuComponent = m.DialogMenuComponent;
        });

        import('./dialog-message/dialog-message.component').then((m) => {
            this.dialogMessageComponent = m.DialogMessageComponent;
        });

        import('./dialog-chapter-insert/dialog-chapter-insert.component').then((m) => {
            this.dialogChapterInsertComponent = m.DialogChapterInsertComponent;
        });

        import('./dialog-save/dialog-save.component').then((m) => {
            this.dialogSaveComponent = m.DialogSaveComponent;
        });

        import('./dialog-cloud-cache-conflict/dialog-cloud-cache-conflict.component').then((m) => {
            this.dialogCloudCacheConflictComponent = m.DialogCloudCacheConflictComponent;
        });

        import('./dialog-save-hitset/dialog-save-hitset.component').then((m) => {
            this.dialogSaveHitsetComponent = m.DialogSaveHitsetComponent;
        });

        import('./dialog-search-views/dialog-search-views.component').then((m) => {
            this.dialogSearchViewsComponent = m.DialogSearchViewsComponent;
        });

        import('./dialog-search-binary-tree/dialog-search-binary-tree.component').then((m) => {
            this.dialogSearchBinaryTreeComponent = m.DialogSearchBinaryTreeComponent;
        });

        import('./dialog-search-conditions/dialog-search-conditions.component').then((m) => {
            this.dialogSearchConditionsComponent = m.DialogSearchConditionsComponent;
        });

        import('./dialog-confirm/dialog-confirm.component').then((m) => {
            this.dialogConfirmComponent = m.DialogConfirmComponent;
        });

        import('./dialog-export/dialog-export.component').then((m) => {
            this.dialogExportComponent = m.DialogExportComponent;
        });

        import('./dialog-share/dialog-share.component').then((m) => {
            this.dialogShareComponent = m.DialogShareComponent;
        });

        import('./dialog-project-list/dialog-project-list.component').then((m) => {
            this.dialogProjectListComponent = m.DialogProjectListComponent;
        });

        import('./dialog-notepad-list/dialog-notepad-list.component').then((m) => {
            this.dialogNotepadListComponent = m.DialogNotepadListComponent;
        });

        import('./dialog-reader-list/dialog-reader-list.component').then((m) => {
            this.dialogReaderListComponent = m.DialogReaderListComponent;
        });

        import('./dialog-sort/dialog-sort.component').then((m) => {
            this.dialogSortComponent = m.DialogSortComponent;
        });

        import('./dialog-keyword/dialog-keyword.component').then((m) => {
            this.dialogKeywordComponent = m.DialogKeywordComponent;
        });

        import('./dialog-keyword-group-editor/dialog-keyword-group-editor.component').then((m) => {
            this.dialogKeywordGroupEditorComponent = m.DialogKeywordGroupEditorComponent;
        });

        import(
            './dialog-item-detail-panel-selection/dialog-item-detail-panel-selection.component'
        ).then((m) => {
            this.dialogItemDetailPanelSelectionComponent =
                m.DialogItemDetailPanelSelectionComponent;
        });

        import('./dialog-team-invitation/dialog-team-invitation.component').then((m) => {
            this.dialogTeamInvitationComponent = m.DialogTeamInvitationComponent;
        });

        import('./dialog-team-generate-code/dialog-team-generate-code.component').then((m) => {
            this.dialogTeamGenerateCodeComponent = m.DialogTeamGenerateCodeComponent;
        });
        import('./dialog-team-change-role/dialog-team-change-role.component').then((m) => {
            this.dialogTeamChangeRoleComponent = m.DialogTeamChangeRoleComponent;
        });

        import('./dialog-team-group-invitation/dialog-team-group-invitation.component').then(
            (m) => {
                this.dialogTeamGroupInvitationComponent = m.DialogTeamGroupInvitationComponent;
            },
        );

        import('./dialog-more/dialog-more.component').then((m) => {
            this.dialogMoreComponent = m.DialogMoreComponent;
        });

        import('./dialog-filter-panel-2/dialog-filter-panel-2.component').then((m) => {
            this.dialogFilterPanel2Component = m.DialogFilterPanel2Component;
        });

        import('./dialog-tags-editor/dialog-tags-editor.component').then((m) => {
            this.dialogTagsEditorComponent = m.DialogTagsEditorComponent;
        });

        import('./dialog-ratings-editor/dialog-ratings-editor.component').then((m) => {
            this.dialogRatingsEditorComponent = m.DialogRatingsEditorComponent;
        });

        import('./dialog-conditions-editor/dialog-conditions-editor.component').then((m) => {
            this.dialogConditionsEditorComponent = m.DialogConditionsEditorComponent;
        });

        import('./dialog-values-editor/dialog-values-editor.component').then((m) => {
            this.dialogValuesEditorComponent = m.DialogValuesEditorComponent;
        });

        import('./dialog-login/dialog-login.component').then((m) => {
            this.dialogLoginComponent = m.DialogLoginComponent;
        });

        import('./dialog-logout/dialog-logout.component').then((m) => {
            this.dialogLogoutComponent = m.DialogLogoutComponent;
        });

        import('./dialog-invitation-code-accept/dialog-invitation-code-accept.component').then(
            (m) => {
                this.dialogInvitationCodeAcceptComponent = m.DialogInvitationCodeAcceptComponent;
            },
        );

        import('./dialog-user-identificator/dialog-user-identificator.component').then((m) => {
            this.dialogUserIdentificatorComponent = m.DialogUserIdentificatorComponent;
        });

        import('./dialog-cloud-error/dialog-cloud-error.component').then((m) => {
            this.dialogCloudErrorComponent = m.DialogCloudErrorComponent;
        });

        import('./dialog-column-c-preview/dialog-column-c-preview.component').then((m) => {
            this.dialogColumnCPreviewComponent = m.DialogColumnCPreviewComponent;
        });

        import('./dialog-add-collection-item/dialog-add-collection-item.component').then((m) => {
            this.dialogAddCollectionItemComponent = m.DialogAddCollectionItemComponent;
        });

        import('./dialog-local-to-cloud/dialog-local-to-cloud.component').then((m) => {
            this.dialogLocalToCloudComponent = m.DialogLocalToCloudComponent;
        });

        import('./dialog-search-archive/dialog-search-archive.component').then((m) => {
            this.dialogSearchArchiveComponent = m.DialogSearchArchiveComponent;
        });

        import('./dialog-notepad/dialog-notepad.component').then((m) => {
            this.dialogNotepadComponent = m.DialogNotepadComponent;
        });

        import('./dialog-note-xitem/dialog-note-xitem.component').then((m) => {
            this.dialogNoteXitemComponent = m.DialogNoteXitemComponent;
        });

        import('./dialog-item-detail/dialog-item-detail.component').then((m) => {
            this.dialogItemDetailComponent = m.DialogItemDetailComponent;
        });

        import('./dialog-story-item-notepad-items/dialog-story-item-notepad-items.component').then(
            (m) => {
                this.dialogStoryItemNotepadItemsComponent = m.DialogStoryItemNotepadItemsComponent;
            },
        );

        import('./dialog-report-as-project/dialog-report-as-project.component').then((m) => {
            this.dialogReportAsProjectComponent = m.DialogReportAsProjectComponent;
        });

        import('./dialog-publication/dialog-publication.component').then((m) => {
            this.dialogPublicationComponent = m.DialogPublicationComponent;
        });

        import('./dialog-project-new/dialog-project-new.component').then((m) => {
            this.dialogProjectNewComponent = m.DialogProjectNewComponent;
        });

        import('./dialog-report-preview/dialog-report-preview.component').then((m) => {
            this.dialogReportPreviewComponent = m.DialogReportPreviewComponent;
        });

        import('./dialog-open-project-in-progress/dialog-open-project-in-progress.component').then(
            (m) => {
                this.dialogOpenProjectInProgressComponent = m.DialogOpenProjectInProgressComponent;
            },
        );

        import('./dialog-upload-info/dialog-upload-info.component').then((m) => {
            this.dialogUploadInfoComponent = m.DialogUploadInfoComponent;
        });

        import('./stage-export-link-dialog/stage-export-link-dialog.component').then((m) => {
            this.stageExportLinkDialogComponent = m.StageExportLinkDialogComponent;
        });

        import('./dialog-devtools/dialog-devtools.component').then((m) => {
            this.dialogDevtoolsComponent = m.DialogDevtoolsComponent;
        });

        import('./dialog-autouser-transfer/dialog-autouser-transfer.component').then((m) => {
            this.dialogAutouserTransferComponent = m.DialogAutouserTransferComponent;
        });

        import(
            './dialog-autouser-edit-binary-tree/dialog-autouser-edit-binary-tree.component'
        ).then((m) => {
            this.dialogAutouserEditBinaryTreeComponent = m.DialogAutouserEditBinaryTreeComponent;
        });

        import('./dialog-batch-selection/dialog-batch-selection.component').then((m) => {
            this.dialogBatchSelectionComponent = m.DialogBatchSelectionComponent;
        });

        import('./dialog-batch-references/dialog-batch-references.component').then((m) => {
            this.dialogBatchReferencesComponent = m.DialogBatchReferencesComponent;
        });

        import('./dialog-evidence-quote/dialog-evidence-quote.component').then((m) => {
            this.dialogEvidenceQuoteComponent = m.DialogEvidenceQuoteComponent;
        });

        import('./dialog-user-group-list/dialog-user-group-list.component').then((m) => {
            this.dialogUserGroupListComponent = m.DialogUserGroupListComponent;
        });

        import('./snackbar-main/snackbar-main.component').then((m) => {
            this.coords.display$.defaultSnackbarComponent = m.SnackbarMainComponent;
        });

        import('./dialog-user-license/dialog-user-license.component').then((m) => {
            this.dialogUserLicenseComponent = m.DialogUserLicenseComponent;
        });

        import('./dialog-unsubscribe/dialog-unsubscribe.component').then((m) => {
            this.dialogUnsubscribeComponent = m.DialogUnsubscribeComponent;
        });

        import('./dialog-memowl-web/dialog-memowl-web.component').then((m) => {
            this.dialogMemowlWebComponent = m.DialogMemowlWebComponent;
        });

        import('./dialog-providers/dialog-providers.component').then((m) => {
            this.dialogProvidersComponent = m.DialogProvidersComponent;
        });

        import('./dialog-countdown/dialog-countdown.component').then((m) => {
            this.dialogCountdownComponent = m.DialogCountdownComponent;
        });
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
        this.coords.display$.click$.next(event);
    }

    private get _dialogRef(): MatDialogRef<any> | undefined {
        return this.dialog.openDialogs.length == 0 ? undefined : this.dialog.openDialogs[0];
    }

    private async _miscDialog(params: any) {
        let cls;
        if (this.coords.display$.isExternalLogin) return;
        switch (params.action) {
            case 'connection-step':
                switch (params.step) {
                    case 1:
                        cls = this.dialogConnectionStep1Component;
                        break;
                    case 2:
                        cls = this.dialogConnectionStep2Component;
                        break;
                    case 3:
                        cls = this.dialogConnectionStep3Component;
                        break;
                    case 4:
                        cls = this.dialogConnectionStep4Component;
                        break;
                }
                break;
            case 'delete':
                // cls = DialogDeleteComponent;
                cls = this.dialogDeleteComponent;
                params.isNarrow = true;
                break;
            case 'user-detail':
                // cls = DialogUserDetailComponent;
                cls = this.dialogUserDetailComponent;
                break;
            case 'user-license':
                // cls = DialogUserDetailComponent;
                cls = this.dialogUserLicenseComponent;
                break;
            case 'in-progress':
                // cls = DialogInProgressActionsComponent;
                cls = this.dialogInProgressActionsComponent;
                break;
            case 'start':
                if (!this.coords.worker$.isReady) return;
                if (
                    this.coords.display$.isStartDialogOpen ||
                    this.coords.isHub ||
                    this.coords.isLicenseManager
                )
                    return;
                cls = this.dialogStartComponent;
                break;
            case 'system':
                // cls = DialogSystemComponent;
                cls = this.dialogSystemComponent;
                break;
            case 'scripts':
                // cls = DialogScriptsComponent;
                cls = this.dialogScriptsComponent;
                params.disableClose = true;
                this.coords.display$.scriptsDialog = this.dialog.open(
                    cls,
                    this._dialogConfig(params),
                );
                return;
            case 'connection-online':
                // cls = DialogConnectionOnlineComponent;
                cls = this.dialogConnectionOnlineComponent;
                break;
            case 'connection-script':
                // cls = DialogConnectionScriptComponent;
                cls = this.dialogConnectionScriptComponent;
                break;
            case 'bulk':
                // cls = DialogBulkComponent;
                cls = this.dialogBulkComponent;
                params.isWide = true;
                break;
            case 'logs':
                // cls = DialogLogsComponent;
                cls = this.dialogLogsComponent;
                params.isWide = true;
                break;
            case 'attachment':
                // cls = DialogAttachmentComponent;
                cls = this.dialogAttachmentComponent;

                params.isWide = true;
                break;
            case 'edit-attachment':
                // cls = DialogAttachmentEditComponent;
                cls = this.dialogAttachmentEditComponent;
                params.isWide = true;
                break;
            case 'edit-image':
                // cls = DialogImageComponent;
                cls = this.dialogImageComponent;
                params.isWide = true;
                break;
            case 'help-in-context':
                // cls = DialogHelpInContextComponent;
                cls = this.dialogHelpInContextComponent;
                params.isWide = true;
                params.disableClose = true;
                this.coords.display$.helpDialog = this.dialog.open(cls, this._dialogConfig(params));
                return;
            case 'mouse-over':
                // cls = DialogMouseOverComponent;
                cls = this.dialogMouseOverComponent;
                params.disableBackdrop = true;
                params.isNarrow = true;
                this.coords.display$.mouseOverDialog = this.dialog.open(
                    cls,
                    this._dialogConfig(params),
                );
                return;
            case 'unsubscribe':
                cls = this.dialogUnsubscribeComponent;
                break;
            case 'menu':
                // cls = DialogMenuComponent;
                cls = this.dialogMenuComponent;
                params.disableBackdrop = true;
                params.disableClose = true;
                params.isMenu = true;
                const md = this.coords.display$.menuDialog;
                md && md.close();
                if (this.coords)
                    this.coords.display$.menuDialog = this.dialog.open(
                        cls,
                        this._dialogConfig(params),
                    );
                return;
            case 'message':
                // cls = DialogMessageComponent;
                cls = this.dialogMessageComponent;
                params.isWide = true;
                break;

            case 'chapter-insert':
                // cls = DialogChapterInsertComponent;
                cls = this.dialogChapterInsertComponent;
                params.isWide = true;
                break;
            case 'save':
                // cls = DialogSaveComponent;
                cls = this.dialogSaveComponent;

                break;
            // case "load":
            //   cls = DialogLoadComponent
            //   break

            case 'cache-conflict':
                // cls = DialogCloudCacheConflictComponent;
                cls = this.dialogCloudCacheConflictComponent;
                break;
            case 'save-hitset':
                // cls = DialogSaveHitsetComponent;
                cls = this.dialogSaveHitsetComponent;

                break;
            case 'search-view':
                // cls = DialogSearchViewsComponent;
                cls = this.dialogSearchViewsComponent;
                break;

            case 'search-binary-tree':
                // cls = DialogSearchBinaryTreeComponent;
                cls = this.dialogSearchBinaryTreeComponent;
                break;
            case 'search-condition':
                // cls = DialogSearchConditionsComponent;
                cls = this.dialogSearchConditionsComponent;
                break;
            case 'confirm':
                // cls = DialogConfirmComponent;
                cls = this.dialogConfirmComponent;
                break;
            case 'export':
                // cls = DialogExportComponent;
                cls = this.dialogExportComponent;
                params.isNarrow = true;
                break;
            case 'share':
                // cls = DialogShareComponent;
                cls = this.dialogShareComponent;
                break;
            case 'project-list':
                // cls = DialogProjectListComponent;
                cls = this.dialogProjectListComponent;
                break;
            case 'notepad-list':
                // cls = DialogNotepadListComponent;
                cls = this.dialogNotepadListComponent;
                break;
            case 'reader-list':
                // cls = DialogReaderListComponent;
                cls = this.dialogReaderListComponent;
                break;
            case 'sort':
                // cls = DialogSortComponent;
                cls = this.dialogSortComponent;
                params.isNarrow = true;
                break;
            case 'keyword':
                // cls = DialogKeywordComponent;
                cls = this.dialogKeywordComponent;
                break;
            case 'keyword-group':
                // cls = DialogKeywordGroupEditorComponent;
                cls = this.dialogKeywordGroupEditorComponent;
                break;
            case 'dataset-visible-panels':
                // cls = DialogItemDetailPanelSelectionComponent;
                cls = this.dialogItemDetailPanelSelectionComponent;
                params.isNarrow = true;
                break;
            case 'team-invitation':
                // cls = DialogTeamInvitationComponent;
                cls = this.dialogTeamInvitationComponent;
                break;
            case 'team-generate':
                // cls = DialogTeamGenerateCodeComponent;
                cls = this.dialogTeamGenerateCodeComponent;

                params.isNarrow = true;
                break;
            case 'team-change-role':
                // cls = DialogTeamChangeRoleComponent;
                cls = this.dialogTeamChangeRoleComponent;
                params.isNarrow = true;
                params.data = { element: params.element };
                break;
            case 'team-group-invitation':
                // cls = DialogTeamGroupInvitationComponent;
                cls = this.dialogTeamGroupInvitationComponent;
                break;
            case 'more':
                // cls = DialogMoreComponent;
                cls = this.dialogMoreComponent;
                break;
            // case 'filter-panel':
            //     cls = DialogFilterPanelComponent;
            //     params.isWide = true;
            //     break;
            case 'filter-panel-2':
                // cls = DialogFilterPanel2Component;
                cls = this.dialogFilterPanel2Component;
                params.isWide = true;
                break;
            // case 'filter':
            //     cls = DialogFilterComponent;
            //     break;
            case 'tags-editor':
                // cls = DialogTagsEditorComponent;
                cls = this.dialogTagsEditorComponent;
                break;
            case 'ratings-editor':
                // cls = DialogRatingsEditorComponent;
                cls = this.dialogRatingsEditorComponent;
                break;
            case 'conditions-editor':
                // cls = DialogConditionsEditorComponent;
                cls = this.dialogConditionsEditorComponent;
                break;
            case 'values-editor':
                // cls = DialogValuesEditorComponent;
                cls = this.dialogValuesEditorComponent;
                break;
            case 'formula-editor':
                // cls = DialogFormulaEditorComponent;
                cls = this.dialogFormulaEditorComponent;
                break;
            // case 'values-template-editor':
            //     cls = DialogValuesTemplateEditorComponent;
            //     break;
            case 'login':
                // cls = DialogLoginComponent;
                cls = this.dialogLoginComponent;
                break;
            case 'logout':
                // cls = DialogLogoutComponent;
                cls = this.dialogLogoutComponent;
                break;
            case 'accept-code':
                // cls = DialogInvitationCodeAcceptComponent;
                cls = this.dialogInvitationCodeAcceptComponent;
                break;
            case 'providers':
                // cls = DialogProvidersComponent;
                cls = this.dialogProvidersComponent;
                break;
            case 'user-identificators':
                // cls = DialogUserIdentificatorComponent;
                cls = this.dialogUserIdentificatorComponent;
                break;
            case 'cloud-error':
                // cls = DialogCloudErrorComponent;
                cls = this.dialogCloudErrorComponent;
                break;
            case 'column_c':
                // cls = DialogColumnCPreviewComponent;
                cls = this.dialogColumnCPreviewComponent;
                break;
            case 'add-collection-item':
                // cls = DialogAddCollectionItemComponent;
                cls = this.dialogAddCollectionItemComponent;
                break;

            case 'local-to-cloud':
                // cls = DialogLocalToCloudComponent;
                cls = this.dialogLocalToCloudComponent;
                params.isWide = true;
                break;
            case 'memowl-web':
                // cls = DialogMemowlWebComponent;
                cls = this.dialogMemowlWebComponent;
                params.isWide = true;
                break;
            case 'search-archive':
                // cls = DialogSearchArchiveComponent;
                cls = this.dialogSearchArchiveComponent;
                params.isWide = true;
                break;
            case 'notepad':
                // cls = DialogNotepadComponent;
                cls = this.dialogNotepadComponent;
                params.isWide = true;
                break;
            case 'pdf':
                // cls = DialogPdfComponent;
                cls = this.dialogPdfComponent;
                params.isFull = true;
                break;
            case 'note-xitem':
                // cls = DialogNoteXitemComponent;
                cls = this.dialogNoteXitemComponent;
                params.isFull = true;
                break;
            case 'xitem':
                // cls = DialogItemDetailComponent;
                cls = this.dialogItemDetailComponent;
                params.isFull = true;
                break;
            case 'story-item-notepad-items':
                // cls = DialogStoryItemNotepadItemsComponent;
                cls = this.dialogStoryItemNotepadItemsComponent;
                params.isFull = true;
                break;
            case 'project-export':
            case 'report-project':
                // cls = DialogReportAsProjectComponent;
                cls = this.dialogReportAsProjectComponent;
                params.isWide = true;
                break;
            case 'publication':
                // cls = DialogPublicationComponent;
                cls = this.dialogPublicationComponent;
                params.isWide = true;
                break;
            case 'project-new':
                // cls = DialogProjectNewComponent;
                cls = this.dialogProjectNewComponent;
                params.isWide = true;
                break;
            case 'report-project-preview':
                // cls = DialogReportPreviewComponent;
                cls = this.dialogReportPreviewComponent;
                params.isWide = true;
                break;
            case 'user-group':
                // cls = DialogUserGroupComponent;
                cls = this.dialogUserGroupComponent;

                params.isWide = true;
                break;
            case 'user-group-list':
                // cls = DialogUserGroupListComponent;
                cls = this.dialogUserGroupListComponent;
                params.isWide = true;
                break;
            case 'open-project-in-progress':
                // cls = DialogOpenProjectInProgressComponent;
                cls = this.dialogOpenProjectInProgressComponent;
                params.isStart = true;
                break;
            case 'upload-info':
                // cls = DialogUploadInfoComponent;
                cls = this.dialogUploadInfoComponent;

                params.isWide = true;
                break;
            case 'export-project-link':
                // cls = StageExportLinkDialogComponent;
                cls = this.stageExportLinkDialogComponent;

                break;
            case 'devtools':
                // cls = DialogDevtoolsComponent;
                cls = this.dialogDevtoolsComponent;

                break;
            case 'hub-publish':
                // cls = DialogHubUploadComponent;
                cls = this.dialogHubUploadComponent;
                params.isWide = true;
                break;
            case 'autouser-transfer':
                // cls = DialogAutouserTransferComponent;
                cls = this.dialogAutouserTransferComponent;
                params.isWide = true;
                break;
            case 'autouser-edit-bt':
                // cls = DialogAutouserEditBinaryTreeComponent;
                cls = this.dialogAutouserEditBinaryTreeComponent;

                params.isWide = true;
                break;
            case 'batch-select':
                // cls = DialogBatchSelectionComponent;
                cls = this.dialogBatchSelectionComponent;

                params.isWide = true;
                break;
            case 'batch-references':
                // cls = DialogBatchReferencesComponent;
                cls = this.dialogBatchReferencesComponent;
                params.isWide = true;
                break;
            case 'evidence-quote':
                // cls = DialogEvidenceQuoteComponent;
                cls = this.dialogEvidenceQuoteComponent;
                break;
            case 'countdown':
                // cls = DialogCountdownComponent;
                cls = this.dialogCountdownComponent;
                break;
            default:
                return console.log('UNKNOWN', params);
        }

        if (!cls) {
            setTimeout(() => {
                console.log('RETRY DIALOG', params);
                this._miscDialog(params);
            }, 30);
            return;
        }

        this.coords.display$.lastDialogAction = params.action;
        this._open(cls, params);
    }

    private _open(cls: any, params: any) {
        if (!params.isStandalone) this.dialog.closeAll();
        const d = this.dialog.open(cls, this._dialogConfig(params));
        if (params.isStandalone) this.coords.display$.standaloneDialog = d;
    }

    _dialogConfig(params: any) {
        const panelLs = ['modal-Panel'];
        const backdropLs = ['modal-Backdrop'];
        if (params.isNarrow) {
            panelLs.push('narrow');
        } else if (params.isWide) {
            panelLs.push('wide');
        } else if (params.isFull) {
            panelLs.push('full');
        } else if (params.isMenu) {
            panelLs.push('menu');
        } else if (params.isStart) {
            panelLs.push('start_dialog');
            backdropLs.push('start_dialog_backdrop');
        }
        if (params.isMenu) {
            if (params.position.left) {
                const oldLeft = parseInt(params.position.left);
                const viewportWidth = window.innerWidth;
                const fromRight = 150;
                if (oldLeft + fromRight > viewportWidth) {
                    params.position.left = `${viewportWidth - fromRight}px`;
                }
            }
        }

        const clsLs = [params.action, params.type].filter((x) => x);

        clsLs.forEach((x) => {
            panelLs.push(`my-panel-${x}`);
            backdropLs.push(`my-backdrop-${x}`);
        });

        return Object.assign(
            {
                disableClose: params.disableClose || !this.coords.project$.current,
                autoFocus: false,
                data: params,
                panelClass: panelLs,
                hasBackdrop: !params.disableBackdrop,
                backdropClass: backdropLs,
            },
            params,
        );
    }

    @HostListener('document:keyup', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        this.coords.keyboard$.keyup(event);
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: Event): void {
        this.coords.display$.checkScreenTablet();
        const wasMobile = this.isMobile;
        this.isMobile = window.innerWidth < 768;
        if (!this.isMobile && wasMobile) {
            this._miscDialog({ action: 'start' });
        }
        if (this.isMobile && !wasMobile) {
            this.dialog.closeAll();
        }
    }
}
